// /app/frontend/src/pages/risk/dpia/steps/NecessityStep.jsx
import React from 'react';
import { Label } from '../../../../components/ui/label';
import { Textarea } from '../../../../components/ui/textarea';
import { Checkbox } from '../../../../components/ui/checkbox';

export default function NecessityStep({ formData, updateField }) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label>How does this data processing achieve project objectives?</Label>
        <Textarea 
          value={formData.how_data_achieves_objectives}
          onChange={(e) => updateField('how_data_achieves_objectives', e.target.value)}
          placeholder="Explain why this data processing is necessary..."
          rows={4}
        />
      </div>

      <div className="space-y-2">
        <Label>Have you considered less data-intensive alternatives?</Label>
        <Textarea 
          value={formData.alternative_methods}
          onChange={(e) => updateField('alternative_methods', e.target.value)}
          placeholder="Describe alternatives considered and why they were rejected..."
          rows={3}
        />
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox 
          id="can_anonymise" 
          checked={formData.can_use_anonymised}
          onCheckedChange={(checked) => updateField('can_use_anonymised', checked)}
        />
        <Label htmlFor="can_anonymise">Could anonymised or pseudonymised data be used instead?</Label>
      </div>

      {!formData.can_use_anonymised && (
        <div className="space-y-2 pl-6 border-l-2 border-primary/20">
          <Label>If not, explain why</Label>
          <Textarea 
            value={formData.anonymised_explanation}
            onChange={(e) => updateField('anonymised_explanation', e.target.value)}
            placeholder="Why can't anonymised data achieve the objective?"
            rows={2}
          />
        </div>
      )}

      <div className="space-y-2">
        <Label>How will function creep be prevented?</Label>
        <Textarea 
          value={formData.function_creep_prevention}
          onChange={(e) => updateField('function_creep_prevention', e.target.value)}
          placeholder="Measures to prevent data being used for unintended purposes..."
          rows={3}
        />
      </div>

      <div className="space-y-2">
        <Label>Data Quality Measures</Label>
        <Textarea 
          value={formData.data_quality_measures}
          onChange={(e) => updateField('data_quality_measures', e.target.value)}
          placeholder="How will data accuracy, completeness, and currency be maintained?"
          rows={3}
        />
      </div>
    </div>
  );
}
